var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAssociation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7503 4.51343C12.3025 4.51343 12.7503 4.96114 12.7503 5.51343V11.2336L18.2227 9.65271C18.7533 9.49943 19.3077 9.8053 19.461 10.3359C19.6143 10.8665 19.3084 11.4209 18.7778 11.5741L13.3817 13.133L16.6154 17.6842C16.9353 18.1344 16.8297 18.7587 16.3795 19.0786C15.9293 19.3985 15.305 19.2928 14.9851 18.8426L11.7503 14.2899L8.51542 18.8426C8.19554 19.2928 7.57125 19.3985 7.12104 19.0786C6.67082 18.7587 6.56518 18.1344 6.88506 17.6842L10.1188 13.133L4.72272 11.5741C4.19213 11.4209 3.88626 10.8665 4.03954 10.3359C4.19283 9.8053 4.74721 9.49943 5.2778 9.65271L10.7503 11.2336V5.51343C10.7503 4.96114 11.198 4.51343 11.7503 4.51343Z",
    fill: "#FF5800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAssociation);
export default __webpack_public_path__ + "static/media/profile_association.ff94c4b137f50c3f9891669cfbeb4193.svg";
export { ForwardRef as ReactComponent };